import { useCallback, useEffect, useState } from 'react';
import { Card, Button, Select, Input, Table, Row, Col, Space, Modal, Dropdown, Typography, Divider } from 'antd';
import { PlusOutlined, CopyOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';
import { searchCompte } from '../../../hooks/useSearch';
import "../../../assets/styles/comptabilite.css";

const { Option } = Select;

const { Title, Text } = Typography;

const SchemaEcritures = () => {
    const [reload, setReload] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modules, setModules] = useState([]);
    const [journaux, setJournaux] = useState([]);
    const [comptes, setComptes] = useState([]);
    const [journal, setJournal] = useState('');
    const [module, setModule] = useState('');
    const [label, setLabel] = useState('');
    const [code, setCode] = useState('');
    const [description, setDescription] = useState('');
    const [schemas, setSchemas] = useState([]);
    // Pour la ligne d'ecriture
    const [isModalOpenLine, setIsModalOpenLine] = useState(false);
    const [typeLigne, setTypeLigne] = useState('');
    const [compte, setCompte] = useState('');
    const [selectedCompte, setSelectedCompte] = useState('');
    const [compteSearch, setCompteSearch] = useState('');
    const [libelle, setLibelle] = useState('');
    const [sens, setSens] = useState('');
    const [montant, setMontant] = useState('');
    const [schema, setSchema] = useState('');
    const [ligne, setLigne] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [duplicateMode, setDuplicateMode] = useState(false);
    const [lignes, setLignes] = useState([]);

    const columns = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
        },
        {
            title: 'Libellé',
            dataIndex: 'label',
            key: 'label',
        },
        {
            title: 'Journal',
            dataIndex: 'journal',
            key: 'journal',
            render: (journal) => journal?.intitule,
        },
        {
            title: 'Module',
            dataIndex: 'module',
            key: 'module',
            render: (module) => module?.nom,
        },
        {
            title: 'Dernière modif.',
            dataIndex: 'lastModified',
            key: 'lastModified',
            render: (_, record) => new Date(record?.updatedAt ? record?.updatedAt : record?.createdAt).toLocaleDateString(),
        },
        {
            title: 'Actions',
            key: 'actions',
            align: 'right',
            render: (_, record) => (
                <Dropdown menu={{
                    items: [
                        {
                            key: 'edit',
                            label: 'Modifier',
                            onClick: () => {
                                handleShowSchema(record, 'edit');
                            },
                        },
                        {
                            key: 'duplicate',
                            label: 'Dupliquer',
                            onClick: () => {
                                handleShowSchema(record, 'duplicate');
                            },
                        },
                        {
                            key: 'delete',
                            label: 'Supprimer',
                        },
                    ]
                }}>
                    <Button icon={<SettingOutlined />} />
                </Dropdown>
            ),
        },
    ];

    const handleShowSchema = (record, mode) => {
        if (mode === 'edit') {
            setEditMode(true);
            setLabel(record.label);
            setCode(record.code);
            setSchema(record);
        } else if (mode === 'duplicate') {
            setDuplicateMode(true);
            setLabel(record.label + ' Copie');
            generateCodeSchemaEcriture(record.label + ' Copie');
        }
        setLignes(record.lignes);
        setDescription(record.description);
        setJournal(JSON.stringify(record.journal));
        setModule(JSON.stringify(record.module));
        setIsModalOpen(true);
    }

    useEffect(() => {
        axiosInstance.get(`/api/module/all/comptable`)
            .then((res) => {
                setModules(res.data);
            }).catch((err) => {
                console.log(err);
            });

        axiosInstance.get(`/api/journal-comptable`)
            .then((res) => {
                setJournaux(res.data);
            }).catch((err) => {
                console.log(err);
            });

        axiosInstance.get(`/api/schema-ecriture-comptable`)
            .then((res) => {
                setSchemas(res.data);
            }).catch((err) => {
                console.log(err);
            });
    }, [reload]);

    useEffect(() => {
        searchCompte(compteSearch)
            .then((res) => {
                setComptes(res.data.content);
            }).catch((err) => {
                console.log(err);
            });
    }, [compteSearch]);


    const handleAddSchema = () => {

        const sch = {
            ...schema,
            code: code,
            label: label,
            journal: JSON.parse(journal),
            module: JSON.parse(module),
            description: description,
            lignes: lignes
        }

        console.log(sch);

        editMode ? axiosInstance.put(`/api/schema-ecriture-comptable`, JSON.stringify(sch)) : axiosInstance.post(`/api/schema-ecriture-comptable`, JSON.stringify(sch))
            .then((res) => {
                console.log(res.data);
                setSchemas([...schemas, res.data]);
                toast(duplicateMode ? "Schéma dupliqué avec succès" : editMode ? "Schéma modifié avec succès" : "Schéma ajouté avec succès");
                setReload(true);
                handleCancel();
            }).catch((err) => {
                console.log(err);
                toast.error("Erreur lors de l'enregistrement du schéma");
            });
    }

    const handleCancel = () => {
        setIsModalOpen(false);
        setCode('');
        setLabel('');
        setJournal('');
        setModule('');
        setDescription('');
        setEditMode(false);
        setDuplicateMode(false);
    }

    const handleCancelLine = () => {
        setIsModalOpenLine(false);
        setLibelle('');
        setCompte('');
        setSens('');
        setMontant('');
        setEditMode(false);
        setLigne('');
        setSchema('');
    }

    const ecritureColumns = [
        {
            title: 'DEBIT',
            dataIndex: 'debitLibelle',
            key: 'debitLibelle',
        },
        {
            title: 'CREDIT',
            dataIndex: 'creditLibelle',
            key: 'creditLibelle',
        },
        {
            title: 'LIBELLE',
            dataIndex: 'libelle',
            key: 'libelle',
        },
        {
            title: 'DEBIT',
            dataIndex: 'debit',
            key: 'debit',
        },
        {
            title: 'CREDIT',
            dataIndex: 'credit',
            key: 'credit',
        },
    ];

    const debouncedSetCompteSearchInput = useCallback((value) => {
        const handler = setTimeout(() => {
            setCompteSearch(value);
        }, 10); // Wait 500ms after user stops typing
        // Clean up previous timeout
        return () => clearTimeout(handler);
    }, []);


    const expandedEcritureRowRender = (record) => (
        <Card
            type="inner"
            style={{
                margin: '16px 32px',
                backgroundColor: '#F9FAFC',
                borderColor: '#E0E6F1',
                borderRadius: 8,
                boxShadow: '0 1px 3px rgba(39, 35, 102, 0.05)',
            }}
            bodyStyle={{ padding: 24 }}
        >
            <Space direction="vertical" style={{ width: '100%' }} size="large">
                <div style={{ textAlign: 'center' }}>
                    <Title level={4} style={{ marginBottom: 4, color: '#272366' }}>Écritures</Title>
                    <Text type="secondary">Détail des lignes d’écriture comptable</Text>
                </div>
                <Table
                    bordered
                    columns={ecritureColumns}
                    rowClassName={(record) => (record.key === ligne.ligneEcritureComptableId ? "night-blue-row" : "")}
                    dataSource={record.lignes
                        ?.slice() // copie pour éviter de muter l'original
                        .sort((a, b) => {
                            if (a.direction === 'DEBIT' && b.direction === 'CREDIT') return -1;
                            if (a.direction === 'CREDIT' && b.direction === 'DEBIT') return 1;
                            return 0; // pas de changement si les deux sont identiques
                        })
                        .map((l) => ({
                            key: l.ligneEcritureComptableId,
                            debitLibelle: l.direction === 'DEBIT' ? l.compteComptable?.numero : '',
                            creditLibelle: l.direction === 'CREDIT' ? l.compteComptable?.numero : '',
                            libelle: l.label,
                            debit: l.direction === 'DEBIT' ? l.expressionMontant : '',
                            credit: l.direction === 'CREDIT' ? l.expressionMontant : '',
                            data: l

                        }))
                    }
                    pagination={false}
                    size="small"
                    rowKey="id"
                    style={{ border: '1px solid #E0E6F1', borderRadius: 4 }}
                    onRow={(lineRecord, index) => {
                        return {
                            onClick: (event) => {
                                setEditMode(true);
                                console.log(lineRecord);
                                console.log(record);
                                setSchema(record);
                                setTypeLigne(lineRecord.data?.formuleCompte);
                                setCompte(lineRecord.debitLibelle || lineRecord.creditLibelle);
                                setSelectedCompte(lineRecord.data?.compteComptable);
                                setLibelle(lineRecord.libelle);
                                setSens(lineRecord.data?.direction);
                                setMontant(lineRecord.debit || lineRecord.credit);
                                setLigne(lineRecord.data);
                                setIsModalOpenLine(true);
                            },
                            onContextMenu: (event) => {
                                event.preventDefault();
                                console.log(lineRecord);
                                setLigne(lineRecord.data);
                                setSchema(record);
                                confirmLineDeletion(lineRecord.data, record);
                            }
                        }
                    }}
                />
                <Divider />
                <div style={{ textAlign: 'center' }}>
                    <Title level={5} style={{ color: '#272366' }}>Ajouter une ligne</Title>
                    <Button
                        icon={<PlusOutlined />}
                        type="primary"
                        style={{
                            backgroundColor: '#00BFFF',
                            borderColor: '#00BFFF',
                            color: '#fff',
                        }}
                        onClick={() => {
                            setSchema(record);
                            setIsModalOpenLine(true);
                        }}
                    >
                        Nouvelle ligne
                    </Button>
                </div>
            </Space>
        </Card>
    );

    const generateCodeSchemaEcriture = (value) => {
        let c = value
            .split(' ')
            .map(word => word.trim().substring(0, 4).toUpperCase())
            .join('_');
        if (value.length > 4) {
            axiosInstance.get(`/api/schema-ecriture-comptable/count/${c}`)
                .then((res) => {
                    if (res.data === 0) {
                        setCode(c);
                    } else {
                        setCode(c + res.data);
                    }
                }).catch((err) => {
                    console.log(err);
                });
        }

    }

    const handleAddLine = () => {
        console.log("Ajouter une nouvelle ligne");
        const ecriture = {
            ...ligne,
            label: libelle,
            expressionMontant: montant,
            direction: sens,
            compteComptable: selectedCompte,
            formuleCompte: typeLigne,
        }
        console.log(ecriture);

        if (editMode) {
            axiosInstance.put(`/api/ligne-ecriture-comptable`, JSON.stringify(ecriture))
                .then((res) => {
                    console.log(res.data);
                    toast("Ligne modifiée avec succès");
                    setIsModalOpenLine(false);
                    setReload(true);
                }).catch((err) => {
                    console.log(err);
                    toast.error("Erreur lors de la modification de la ligne");
                });

        } else {
            axiosInstance.post(`/api/ligne-ecriture-comptable/${schema.schemaEcritureComptableId}`, JSON.stringify(ecriture))
                .then((res) => {
                    console.log(res.data);
                    toast("Ligne ajoutée avec succès");
                    setIsModalOpenLine(false);
                    setReload(true);
                }).catch((err) => {
                    console.log(err);
                    toast.error("Erreur lors de l'ajout de la ligne");
                });
        }


    }

    const confirmLineDeletion = (record, sch) => {
        Modal.confirm({
            title: 'Voulez-vous vraiment supprimer cette ligne ?',
            content: 'Toutes vos actions sont historisées !',
            okText: 'Oui',
            okType: 'danger',
            cancelText: 'Annuler',
            onOk() {
                deleteLine(record, sch);
            },
            onCancel() {
                handleCancelLine();
            }

        });
    }

    const deleteLine = (li, sch) => {
        axiosInstance.delete(`/api/ligne-ecriture-comptable/${li.ligneEcritureComptableId}/${sch.schemaEcritureComptableId}`)
            .then((res) => {
                console.log(res.data);
                toast("Ligne supprimée avec succès");
                setIsModalOpenLine(false);
                setReload(true);
            }).catch((err) => {
                console.log(err);
            });
    }

    return (
        <div className="p-6">
            <Card className="shadow-sm">
                <Row justify="space-between" align="middle" style={{ marginBottom: 24 }}>
                    <h4 className="text-xl font-semibold mb-4" style={{ color: '#2D2D2D' }}>Schémas d'Écritures Comptables</h4>
                    <Space>
                        <Button onClick={() => setIsModalOpen(true)} type="primary" icon={<PlusOutlined />}>Nouveau Schéma</Button>
                        {/* <Button icon={<CopyOutlined />}>Dupliquer</Button> */}
                    </Space>
                </Row>
                <p style={{ color: '#666' }}>Configuration des journaux...</p>

                <Row gutter={16} style={{ marginBottom: 24 }}>
                    <Col xs={24} md={8}>
                        <label>Filtrer par journal</label>
                        <Select defaultValue="Tous les types" style={{ width: '100%' }}>
                            <Option value="Tous les types">Tous les journaux</Option>
                            {journaux?.map((journal, id) => <Option key={id} value={journal?.code}>{journal?.code}</Option>)}
                        </Select>
                    </Col>
                    <Col xs={24} md={8}>
                        <label>Filtrer par module</label>
                        <Select defaultValue="Tous les modules" style={{ width: '100%' }}>
                            <Option value="Tous les modules">Tous les modules</Option>
                            {modules?.map((md, id) => (
                                <Option key={id} value={JSON.stringify(md)}>{md.nom}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col xs={24} md={8}>
                        <label>Rechercher</label>
                        <Input
                            placeholder="Nom du schéma..."
                            prefix={<SearchOutlined />}
                        />
                    </Col>
                </Row>

                <Table
                    columns={columns}
                    dataSource={schemas}
                    expandable={{
                        expandedRowRender: expandedEcritureRowRender,
                        defaultExpandedRowKeys: ['0'],
                        expandRowByClick: true,
                    }}
                    pagination={{ showSizeChanger: true }}
                    rowKey="code"
                    style={{ backgroundColor: '#fff', borderRadius: 8, overflow: 'hidden' }}
                    bordered
                />
            </Card>
            <Modal
                title={duplicateMode ? "Dupliquer le schéma" : editMode ? "Modifier le schéma" : "Ajouter un nouveau schéma"}
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Annuler
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleAddSchema}>
                        {duplicateMode ? "Dupliquer" : "Enregistrer"}
                    </Button>,
                ]}
                width={800}
                okText={duplicateMode ? "Dupliquer" : "Enregistrer"}
                cancelText="Annuler"
            >
                <div className="p-6 row">
                    <div className="col-6">
                        <label className="form-label">Code du schéma*</label>
                        <input disabled type="text" className="form-control" placeholder="Ex: FAC_CLI" value={code} />
                    </div>
                    <div className="col-6">
                        <label className="form-label">Libellé*</label>
                        <input type="text" className="form-control" placeholder="Ex: Facturation client" value={label} onChange={(e) => {
                            generateCodeSchemaEcriture(e.target.value);
                            setLabel(e.target.value);
                        }} />
                    </div>
                    <div className="col-6">
                        <label className="form-label">Journal*</label>
                        <select className="form-control" onChange={(e) => setJournal(e.target.value)} value={journal}>
                            <option value="">Sélectionner un journal</option>
                            {journaux?.map((journal, id) => <option key={id} value={JSON.stringify(journal)}>{journal?.intitule} ({journal?.code}) </option>)}
                        </select>
                    </div>
                    <div className="col-6">
                        <label className="form-label">Module*</label>
                        <select className="form-control" onChange={(e) => setModule(e.target.value)} value={module}>
                            <option value="">Sélectionner un module</option>
                            {modules?.map((module, id) => <option key={id} value={JSON.stringify(module)}>{module?.nom}</option>)}
                        </select>
                    </div>
                    <div className="col-12">
                        <label className="form-label">Description</label>
                        <textarea className="form-control" rows="3" placeholder="Description du schéma..." value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                </div>
            </Modal>
            <Modal
                title={editMode ? `Modifier la ligne d'Écriture pour le schéma ${schema?.label}` : `Ajouter une ligne d'Écriture pour le schéma ${schema?.label}`}
                open={isModalOpenLine}
                onCancel={handleCancelLine}
                footer={[
                    <Button key="cancel" onClick={handleCancelLine}>
                        Annuler
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleAddLine}>
                        Enregistrer
                    </Button>,
                ]}
                width={800}
                okText="Enregistrer"
                cancelText="Annuler"
            >
                <div className="p-6 row">
                    <div className="col-6">
                        <label className="form-label">Type de ligne*</label>
                        <select className="form-control" value={typeLigne} onChange={(e) => setTypeLigne(e.target.value)}>
                            <option value="">Sélectionner un type</option>
                            <option value="COMPTE">Compte</option>
                            <option value="FORMULE">Formule</option>
                        </select>
                    </div>
                    <div className="col-6">
                        <label className="form-label">Compte comptable*</label>
                        <br />
                        <Select
                            showSearch
                            placeholder="Sélectionner un compte"
                            optionFilterProp="children"
                            onChange={(e, record) => {
                                setCompte(e);
                                setLibelle(record.data?.intitule);
                                setSelectedCompte(record.data);
                            }}
                            searchValue={compteSearch}
                            onSearch={(value) => {
                                // console.log(value);
                                debouncedSetCompteSearchInput(value);
                            }}
                            value={compte}
                            style={{ width: "100%" }}
                            filterOption={false}
                            options={comptes?.map((r) => ({ label: r.numero, value: r.numero, data: r }))}
                        />
                    </div>
                    <div className="col-6">
                        <label className="form-label">Libellé*</label>
                        <input type="text" className="form-control" placeholder="Libellé de la ligne" value={libelle} onChange={(e) => setLibelle(e.target.value)} />
                    </div>
                    <div className="col-6">
                        <label className="form-label">Sens*</label>
                        <select className="form-control" value={sens} onChange={(e) => setSens(e.target.value)}>
                            <option value="">Sélectionner un sens</option>
                            <option value="DEBIT">Débit</option>
                            <option value="CREDIT">Crédit</option>
                        </select>
                    </div>
                    <div className="col-6">
                        <label className="form-label">Montant*</label>
                        <input type="text" className="form-control" placeholder="Ex: [MONTANT_TTC]" value={montant} onChange={(e) => setMontant(e.target.value)} />
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default SchemaEcritures;
